/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
import React, { useState } from "react";
import Tooltip from '@material-ui/core/Tooltip';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import RCSlider from 'rc-slider';
import notify from '../../../Recommendations/notify';
import { BLUE_LIT } from '../../../../utils/colors';

import {
  Container,
  ContainerAttempts,
  ContainerSlider,
  ButtonCopy
} from './styles';
import SeeAssessment from "../../../CursoNovo/Progress/subcomponents/AssessmentInfo/SeeAssessment";
import { ModalAssessmentMediaList } from "../../../CursoNovo/Progress/subcomponents/AssessmentInfo/ModalAssessmentMediaList";

const Slider = RCSlider;

const ALL_STATUSES = [
  'Não iniciado',
  'Iniciado',
  'Entregue',
  'Em correção',
  'Corrigido'
];

function Summary({ attempts, assessmentCode, type }) {

  const [openModal, setOpenModal] = useState(false);
  const [assessmentMediaList, setAssessmentMediaList] = useState([]);

  const handleAssementMediaView = (item) => {
    setAssessmentMediaList(item);
    setOpenModal(true);
  }

  const processTracking = (tracking) => {
    if (!tracking || tracking.length === 0) return [];
    const processedTracking = [...tracking];
    const lastStatus = processedTracking[processedTracking.length - 1].status;
    if (processedTracking.length === 3 && lastStatus === 'Corrigido' && 
        !processedTracking.some(t => t.status === 'Em correção')) {
      const correctedDate = processedTracking[processedTracking.length - 1].date;
      processedTracking.splice(processedTracking.length - 1, 0, {
        date: correctedDate,
        status: 'Em correção'
      });
    }
    return processedTracking;
  };

  const renderMarks = (max, labels) => {
    const marks = {};
    for (let i = 0; i <= max; i++) {
      marks[i] = labels[i];
    }
    return marks;
  };

  const getStatusIndex = (tracking) => {
    if (!tracking || tracking.length === 0) return 0;
    const processedTracking = processTracking(tracking);
    const currentStatus = processedTracking[processedTracking.length - 1].status;
    return ALL_STATUSES.indexOf(currentStatus);
  };

  const trackingLabels = tracking => {
    const statusDates = {};
    const processedTracking = processTracking(tracking);
    
    if (processedTracking && processedTracking.length > 0) {
      for (const item of processedTracking) {
        if (item.status && item.date) {
          statusDates[item.status] = item.date;
        }
      }
    }

    const labels = ALL_STATUSES.map(status => ({
      label: (
        <>
          <p style={{ marginBottom: 0 }}>{status}</p>
          {statusDates[status] && (
            <p style={{ marginBottom: 0, marginTop: -70 }}>{statusDates[status]}</p>
          )}
        </>
      )
    }));

    return labels.map(item => item.label);
  };

  const handleCopyToClipboard = () => {
    notify('Protocolo copiado com sucesso!');
  };

  const goToAssessmentView = (code, editing = false) => {
    const responseCode = code;
    const redirectRoute = `/assessment-view?assessmentCode=${assessmentCode}&responseCode=${responseCode}&editing=${editing}`;
    window.open(redirectRoute, '__blank');
  };


  return (
    <Container>
      {attempts && attempts.length > 0 && (
        <div style={{ height: 500, overflow: 'auto' }}>
          {attempts.map((item, index) => {
            return (
              <ContainerAttempts key={index}>
                {item.tracking && (
                  <ContainerSlider>
                    <Slider
                      dots
                      dotStyle={() => {
                        return <span>123123</span>;
                      }}
                      disabled
                      id={`component-${item}`}
                      trackStyle={[
                        {
                          backgroundColor: '#27aae1',
                          borderColor: '#27aae1'
                        },
                        { backgroundColor: '#27aae1' }
                      ]}
                      defaultValue={getStatusIndex(item.tracking)}
                      min={0}
                      max={4}
                      marks={renderMarks(4, trackingLabels(item.tracking))}
                    />
                  </ContainerSlider>
                )}
                <div className="table-responsive">
                  <table className="table table-sm table-striped">
                    <thead>
                      <tr>
                        <th scope="col">Tentativa</th>
                        <th scope="col">Protocolo</th>
                        <th scope="col">Data</th>
                        {type === 'EXAM' && (item.assessmentMediaAttached || []).length > 0 && (
                          <th scope="col">Atividade</th>
                        )}
                        <th scope="col">Nota</th>
                        <th scope="col" width="20%">
                          Resultado
                        </th>
                        <th scope="col"> </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{index + 1}</td>
                        <td>
                          <Tooltip
                            title="Clique para copiar"
                            aria-label="add"
                            placement="top"
                          >
                            <CopyToClipboard
                              text={item.crCode}
                              onCopy={handleCopyToClipboard}
                            >
                              <ButtonCopy
                                data-for="copy"
                                data-tip={item.crCode}
                              >
                                {item.crCode.substring(0, 10)}...
                              </ButtonCopy>
                            </CopyToClipboard>
                          </Tooltip>
                        </td>
                        <td>{item.date}</td>
                        {type === 'EXAM' || type === 'FINAL_EXAM' && (item.assessmentMediaAttached || []).length > 0 && (
                          <td><a href='javascript:void(0)' onClick={() => {
                            handleAssementMediaView(item.assessmentMediaAttached)
                          }} style={{ color: BLUE_LIT }}>Ver atividades</a></td>
                        )}
                        <td>
                          {item.tracking &&
                          item.tracking[item.tracking.length - 1].status !==
                            'Corrigido'
                            ? '-'
                            : item.finalGrade}
                        </td>
                        <td>
                          {
                            item.tracking &&
                            item.tracking[item.tracking.length - 1].status !==
                            'Corrigido'
                            ? '-'
                            : item.result
                          }
                        </td>
                    
                        <td>
                          <SeeAssessment item={item} goToAssessmentView={goToAssessmentView} assessmentType={type} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ContainerAttempts>
            );
          })}
        </div>
      )}
        <ModalAssessmentMediaList visible={openModal} onClose={() => setOpenModal(false)} listData={assessmentMediaList} />
    </Container>
  );
}

export default Summary;
